



















































































































































































































































































































































import { defineComponent, ref, computed } from '@nuxtjs/composition-api'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CStepper from '~/components/shared/configurable/stepper/CStepper.vue'
import CCollapse from '~/components/shared/configurable/collapse/CCollapse.vue'
import LoanSection from '~/components/car/classifieds/view/partials/loans/LoanSection.vue'
import TbiLandingLoanSubmitButton from '~/components/car/classifieds/view/partials/loans/calculator/TbiLandingLoanSubmitButton.vue'
import PlusMinusCollapseOpener from '~/components/shared/configurable/collapse/PlusMinusCollapseOpener.vue'
import CBackToTop from '~/components/shared/configurable/CBackToTop.vue'
import { useI18n } from '~/compositions/i18n'
import { useNamespacedStore } from '~/compositions/store'
import {
  USER_AGENT_NS,
  UserAgentState
} from '~/store/modules/shared/userAgent/state'

export default defineComponent({
  components: {
    CImg,
    CStepper,
    LoanSection,
    CCollapse,
    CCard,
    PlusMinusCollapseOpener,
    CBackToTop,
    TbiLandingLoanSubmitButton
  },
  setup() {
    const i18n = useI18n()

    // const { isWithinTbiBlackFridayPeriod } = useBlackFriday()
    // const isBlackFriday = Boolean(route.value.meta?.blackFriday) && isWithinTbiBlackFridayPeriod()
    const isBlackFriday = false

    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )

    const loanAmount = ref(15000)
    const loanInstallments = ref(48)
    const cardDetails = ref([
      {
        imgUrl: '/nuxt-static/img/tbi/fast-process.svg',
        scaleClass: 'xl:tw-scale-125',
        text: 'Γρήγορη & 100% ψηφιακή διαδικασία',
        text_en: 'Quick & 100% digital process'
      },
      {
        imgUrl: '/nuxt-static/img/tbi/instant-money.svg',
        scaleClass: 'xl:tw-scale-125',
        text: 'Με επιτόκιο',
        text_span: 'από 9,9%',
        text_en: 'Interest rate',
        text_en_span: 'from 9.9%'
      },
      {
        imgUrl: '/nuxt-static/img/tbi/no-surprices.svg',
        scaleClass: 'xl:tw-scale-125',
        text: 'Χωρίς προκαταβολή ή εγγύηση',
        text_en: 'No downpayment or collateral required'
      },
      {
        imgUrl: '/nuxt-static/img/tbi/online-process.svg',
        scaleClass: 'xl:tw-scale-150 xl:tw-top-6',
        text: '60 μέρες για να διαλέξεις όχημα',
        text_en: '60 days period to choose a vehicle'
      }
    ])
    const stepperSteps = ref([
      {
        label: '',
        completed: false,
        disabled: false,
        vertical: false,
        round: false,
        selected: true
      },
      {
        label: '',
        completed: false,
        disabled: false,
        vertical: false,
        round: false,
        selected: false
      },
      {
        label: '',
        completed: false,
        disabled: false,
        vertical: false,
        round: false,
        selected: false
      },
      {
        label: '',
        completed: false,
        disabled: false,
        vertical: false,
        round: false,
        selected: false
      },
      {
        label: '',
        completed: false,
        disabled: false,
        vertical: false,
        round: false,
        selected: false
      }
    ])
    const steps = ref([
      {
        hidden: false,
        imgUrl: '/nuxt-static/img/tbi/step-1.png',
        text: `
              <strong>Βήμα 1:</strong> Βλέπεις την Αγγελία που σε ενδιαφέρει και
              χρησιμοποιείς τον υπολογιστή δανείου με ένα ενδεικτικό επιτόκιο.
              `,
        text_en: `
              <strong>Step 1:</strong> You see the Ad you are interested in,
              you use the loan calculator with an indicative interest rate.
              `
      },
      {
        hidden: true,
        imgUrl: '/nuxt-static/img/tbi/step-2.png',
        text: `
              <strong>Βήμα 2:</strong> Συμπληρώνεις την αίτηση
              χρηματοδότησης ψηφιακά σε μερικά λεπτά χωρίς
              να χρειαστεί επίσκεψη σε κατάστημα.
              `,
        text_en: `
              <strong>Step 2:</strong> Fill in the loan application
              digitally in a few minutes without having to visit a physical branch.
              `
      },
      {
        hidden: true,
        imgUrl: '/nuxt-static/img/tbi/step-3.png',
        text: `
              <strong>Βήμα 3:</strong> Λαμβάνεις απάντηση μετά την
              επιβεβαίωση του εισοδήματος και της
              ταυτότητάς σου.
              `,
        text_en: `
              <strong>Step 3:</strong> Get a reply after
              confirmation of your income and identity.
              `
      },
      {
        hidden: true,
        imgUrl: '/nuxt-static/img/tbi/step-4.png',
        text: `
              <strong>Βήμα 4:</strong> Υπογράφεις τη σύμβαση ηλεκτρονικά και
              επιλέγεις τον Ελληνικό σου τραπεζικό
              λογαριασμό για να λάβεις τα χρήματα.
              `,
        text_en: `
              <strong>Step 4:</strong> Sign the contract online and select your Greek bank
              account to receive the money.
              `
      },
      {
        hidden: true,
        imgUrl: '/nuxt-static/img/tbi/step-5.png',
        text: `
              <strong>Βήμα 5:</strong> Έχεις 60 ημέρες, μετά την υπογραφή της
              σύμβασης, να βρεις το όχημα που θες και να μας
              στείλεις ένα αποδεικτικό αγοράς (π.χ. άδεια
              κυκλοφορίας).
              `,
        text_en: `
              <strong>Step 5:</strong> You have 60 days, after signing the contract, to find
              the vehicle you want and send us a proof of purchase (e.g.
              car registration).
              `
      }
    ])
    const faq = ref([
      {
        q: 'Η ερώτηση εδώ;',
        q_en: 'Your question here?',
        a: `Nam ultricies ut sem id hendrerit. Duis vulputate sem sed dapibus euismod.
            Mauris vel diam non lacus interdum placerat et id elit. Sed cursus laoreet
            orci sagittis dapibus. Curabitur a blandit metus. Aenean sed odio mattis,
            laoreet nunc nec, tempus magna. Phasellus pretium mollis diam at semper.
          `,
        a_en: `Nam ultricies ut sem id hendrerit. Duis vulputate sem sed dapibus euismod.
            Mauris vel diam non lacus interdum placerat et id elit. Sed cursus laoreet
            orci sagittis dapibus. Curabitur a blandit metus. Aenean sed odio mattis,
            laoreet nunc nec, tempus magna. Phasellus pretium mollis diam at semper.
          `
      },
      {
        q: 'Η ερώτηση εδώ;',
        q_en: 'Your question here?',
        a: `Nam ultricies ut sem id hendrerit. Duis vulputate sem sed dapibus euismod.
            Mauris vel diam non lacus interdum placerat et id elit. Sed cursus laoreet
            orci sagittis dapibus. Curabitur a blandit metus. Aenean sed odio mattis,
            laoreet nunc nec, tempus magna. Phasellus pretium mollis diam at semper.
          `,
        a_en: `Nam ultricies ut sem id hendrerit. Duis vulputate sem sed dapibus euismod.
            Mauris vel diam non lacus interdum placerat et id elit. Sed cursus laoreet
            orci sagittis dapibus. Curabitur a blandit metus. Aenean sed odio mattis,
            laoreet nunc nec, tempus magna. Phasellus pretium mollis diam at semper.
          `
      },
      {
        q: 'Η ερώτηση εδώ;',
        q_en: 'Your question here?',
        a: `Nam ultricies ut sem id hendrerit. Duis vulputate sem sed dapibus euismod.
            Mauris vel diam non lacus interdum placerat et id elit. Sed cursus laoreet
            orci sagittis dapibus. Curabitur a blandit metus. Aenean sed odio mattis,
            laoreet nunc nec, tempus magna. Phasellus pretium mollis diam at semper.
          `,
        a_en: `Nam ultricies ut sem id hendrerit. Duis vulputate sem sed dapibus euismod.
            Mauris vel diam non lacus interdum placerat et id elit. Sed cursus laoreet
            orci sagittis dapibus. Curabitur a blandit metus. Aenean sed odio mattis,
            laoreet nunc nec, tempus magna. Phasellus pretium mollis diam at semper.
          `
      },
      {
        q: 'Η ερώτηση εδώ;',
        q_en: 'Your question here?',
        a: `Nam ultricies ut sem id hendrerit. Duis vulputate sem sed dapibus euismod.
            Mauris vel diam non lacus interdum placerat et id elit. Sed cursus laoreet
            orci sagittis dapibus. Curabitur a blandit metus. Aenean sed odio mattis,
            laoreet nunc nec, tempus magna. Phasellus pretium mollis diam at semper.
          `,
        a_en: `Nam ultricies ut sem id hendrerit. Duis vulputate sem sed dapibus euismod.
            Mauris vel diam non lacus interdum placerat et id elit. Sed cursus laoreet
            orci sagittis dapibus. Curabitur a blandit metus. Aenean sed odio mattis,
            laoreet nunc nec, tempus magna. Phasellus pretium mollis diam at semper.
          `
      },
      {
        q: 'Η ερώτηση εδώ;',
        q_en: 'Your question here?',
        a: `Nam ultricies ut sem id hendrerit. Duis vulputate sem sed dapibus euismod.
            Mauris vel diam non lacus interdum placerat et id elit. Sed cursus laoreet
            orci sagittis dapibus. Curabitur a blandit metus. Aenean sed odio mattis,
            laoreet nunc nec, tempus magna. Phasellus pretium mollis diam at semper.
          `,
        a_en: `Nam ultricies ut sem id hendrerit. Duis vulputate sem sed dapibus euismod.
            Mauris vel diam non lacus interdum placerat et id elit. Sed cursus laoreet
            orci sagittis dapibus. Curabitur a blandit metus. Aenean sed odio mattis,
            laoreet nunc nec, tempus magna. Phasellus pretium mollis diam at semper.
          `
      }
    ])

    const heroText = computed(() =>
      i18n.locale === 'el'
        ? `
            Απόκτησε τώρα ό,τι επιθυμείς και πλήρωσε με ένα πλάνο δόσεων
            προσανατολισμένο στις ανάγκες σου. Ακόμη κι άν δεν έχεις όλα τα
            χρήματα άμεσα διαθέσιμα, μπορείς να αποκτήσεις το αυτοκίνητο, τη
            μοτοσυκλέτα ή το σκάφος που επιθυμείς με το "Πρόγραμμα Χρηματοδότησης"
            της <strong>tbi</strong> bank.
            `
        : `
            Say yes to a new car, motorcycle, scooter or even a boat
            with 100% online financing without any advance payment
            or guarantee. All without visiting the bank.
            `
    )

    const heroTextBlackFriday = computed(() =>
      i18n.locale === 'el'
        ? `Απόκτησε τώρα το όχημα που επιθυμείς με το πιο ευέλικτο πλάνο
        χρηματοδότησης, τώρα και με 0€ έξοδα διαχείρισης (Black Friday προσφορά,
        ισχύει από 24 έως και 27/11).
        Ακόμη κι αν δεν έχεις όλα τα χρήματα άμεσα
        διαθέσιμα, μπορείς να αποκτήσεις το αυτοκίνητο, τη μοτοσυκλέτα ή το
        σκάφος που επιθυμείς με το "Πρόγραμμα Χρηματοδότησης" της <strong>tbi</strong> bank.`
        : `
        Get the vehicle you want now with the most flexible financing plan,
        now and with 0€ management fees (Black Friday offer, valid from 24 to 27/11).
        Even if you don't have all the money immediately available, you can still get the car,
        the motorbike or the boat you want with tbi bank's "Financing Plan".
            `
    )
    const isMobile = computed(() => userAgentGetters('isMobile'))

    const handleUpdateLoanAmount = (evt: number) => {
      loanAmount.value = evt
    }
    const handleUpdateLoanInstallments = (evt: number) => {
      loanInstallments.value = evt
    }
    const handleChangeStep = (evt: number) => {
      steps.value.forEach((step, i) => {
        i === evt && step.hidden === true
          ? (step.hidden = false)
          : (step.hidden = true)
      })
    }

    return {
      heroText,
      cardDetails,
      stepperSteps,
      steps,
      faq,
      handleChangeStep,
      isMobile,
      handleUpdateLoanAmount,
      handleUpdateLoanInstallments,
      loanAmount,
      loanInstallments,
      isBlackFriday,
      heroTextBlackFriday
    }
  }
})
